import { Component, OnInit, Input } from '@angular/core';
import { isMarkdownV3Child } from './v3-child-link';

@Component({
  selector: 'nns-item-note-list',
  styles: [`
    :host {
      width:100%;
      box-sizing:border-box;
      padding:0 8px;
      display:block;
    }
    :host.first .nns-item-note-link {
      border-top: 1px solid #F5F5F5;
    }
    .nns-item-note-link {
      box-sizing:border-box;
      color:rgba(0,0,0,0.80);
      position:relative;
      display:block;
      border-bottom:1px solid #dcdcdc;
    }
    .nns-item-note-layer {
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      display:block;
      background:#fff;
      box-shadow:none;
      border-radius:0;
      box-shadow: 0px 3.2px 7.2px rgb(0 0 0 / 6%);
    }
    .nns-item-note-main {
      position:relative;
      z-index:5;
      padding:12px;
      overflow:hidden;
      transition:all 0.1s ease-out;
      border-radius:2px;
      min-height:118px;
    }
    .nns-item-note-link:hover {color:rgba(0,0,0,0.80);}
    .nns-item-note-link:hover .nns-item-note-main {background:rgba(236,239,241,0.28);}

    .nns-item-note-meta {
      font-size:12px;
      color:rgba(0,0,0,0.60);
    }
    .nns-item-note-meta-date {padding:0 8px 0 0;}
    .nns-item-note-meta-source {
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }

    .nns-item-note-title {
      display:block;
      width:100%;
      margin:0 0 5px 0;
      overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      line-height:1.3;
      font-size:20px;
      font-weight:400;
    }

    .nns-item-note-img {
      background-size:cover !important;
      width:94px;
      height:94px;
      border-radius:2px;
      overflow:hidden;
      margin:0 0 0 12px;
    }
    .nns-item-note-desc {
      font-size:12px;
      color:rgba(0,0,0,0.60);
      line-height:1.5;
      padding:2px 0 0 0;
    }

    @media only screen and (max-width: 600px) {

      .nns-item-note-main {
        min-height:64px;
      }
      .nns-item-note-title {font-size:15px;}
      .nns-item-note-img {
        width:40px;
        height:40px;
      }

    }
  `, `
    :host-context(.nns-theme-night) .nns-item-note-link {
      color:rgba(255,255,255, 0.8);
    }
    :host-context(.nns-theme-night) .nns-item-note-layer {
      background:#292E32;
      box-shadow:4px 4px 38px rgb(19 30 32 / 66%);
    }
    :host-context(.nns-theme-night) .nns-item-note-link:hover {
      color:#fff;
    }
    :host-context(.nns-theme-night) .nns-item-note-link:hover .nns-item-note-main {
      background:rgba(181,181,181,0.10);
    }

    :host-context(.nns-theme-night) .nns-item-note-meta,
    :host-context(.nns-theme-night) .nns-item-note-desc {
      color:rgba(255,255,255, 0.6);
    }
    :host-context(.nns-theme-night) .nns-item-note-link {
      border-color:#2F3737;
    }
    @media print {
      :host-context(.nns-theme-night) .nns-item-note-main,
      :host-context(.nns-theme-night) .nns-item-note-meta,
      :host-context(.nns-theme-night) .nns-item-note-desc {
        color: #161616;
      }

    }
  `],
  template: `
  <a class="nns-item-note-link" *ngIf="!isV3" [routerLink]="[urlString]"  title="{{item.title | unescape}}">
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </a>
  <!-- a v3 note leaves this app, so it needs a real page load: see isMarkdownV3Child -->
  <a class="nns-item-note-link" *ngIf="isV3" [href]="urlString" title="{{item.title | unescape}}">
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </a>
  <ng-template #body>
    <span class="nns-item-note-layer"></span>
    <span class="nns-item-note-main" flex layout="row" layout-align="start center">

      <span flex layout="column" layout-align="center start">

        <span class="nns-item-note-title" flex="none">
          <span [innerHTML]="item.title"></span>
        </span>
        <span class="nns-item-note-meta" flex="none" layout="row" layout-align="start center">
          <span class="nns-item-note-meta-date" flex="none" *ngIf="date">{{date}}</span>
          <span class="nns-item-note-meta-source" flex *ngIf="item.url">{{item.url}}</span>
        </span>
        <span class="nns-item-note-desc">
          <span [innerHTML]="item.text?.textShort"></span>
        </span>

      </span>

    </span>

  </ng-template>
  `,
})
export class ItemNoteListComponent implements OnInit {
  @Input() public item;
  @Input() public share;
  date;
  urlString;
  isV3 = false;

  ngOnInit() {
    const dateToConvert =  new Date(this.item.dateAdded * 1000);
    this.date = dateToConvert.toLocaleString();
    const shareInstance = this.share.instance;
    this.urlString = `/share/${shareInstance.id}/${shareInstance.securityKey}/${this.item.globalId}`;
    this.isV3 = isMarkdownV3Child(this.item);
  }
}
